<div id="lineChartContainer" #lineChartContainer style="width: 100%; height: 100%; position: relative;"></div>
<div class="listbutton-wrapper" *transloco="let t; prefix: 'fuelShared'">
  <ul class="graph-point distance-graph">
    @for (item of chartConfig(); track item) {
    <li>
      <div class="legend-color" [style]="{'background-color': item.color}"></div>{{item.legend}}
    </li>
    }
  </ul>
  @if (exportBtn()) {
    <div class="export-listing">
      <div class="common-drop-down dropdown">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button"
          data-bs-toggle="dropdown" aria-expanded="false">
          {{ t('export.label') }} <i><img src="./assets/images-fuel/downloadIcon.svg" alt="export-icon" /></i>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdown-button">
          <li><a class="dropdown-item">{{ t('export.asPdf') }}</a></li>
          <li><a class="dropdown-item">{{ t('export.asCsv') }}</a></li>
          <li><a class="dropdown-item">{{ t('export.sendViaEmail') }}</a></li>
        </ul>
      </div>
    </div>
  }
</div>